<template>
    <div class="container">
        <!-- 轮播图组件 -->
        <!-- <carousel :autoplay="true" :autoplay-speed="1000" :loop="true" :pagination-enabled="false" height="300px"
            :per-page="1">
            <slide v-for="(image, index) in images" :key="index">
                <img :src="require('@/assets/images/' + image.filename)" :alt="image.alt"
                    class="img-fluid desktop-image" :style="{ maxHeight: image.maxHeight }">
            </slide>
        </carousel> -->

        <div class="row">
            <div class="col-md-6">
                <div style="display: flex;justify-content: space-around;">
                    <!-- <div style="width: 77%;font-family: sans-serif;font-size: 21px;"> -->
                    <div class="zhengWen">
                        <h2 style="text-align: center;margin-bottom: 40px;">公司简介</h2>
                    <p style="text-indent: 2em;">艾乐肤（广州）生物科技有限公司创建于充满希望的 2024 年。作为ΛKF品牌的中国总经销，公司肩负着重要的使命与责任。</p>

                    <p style="text-indent: 2em;">
                        我们始终致力于推动业务的全面发展，在业务布局上分为线上和线下两大板块。在线上领域，我们凭借先进的电商平台和敏锐的网络营销手段，积极拓展市场覆盖范围，让更多消费者能够便捷地接触和了解到我们经销的优质产品。而在线下，我们通过广泛建立销售渠道、与众多合作伙伴紧密协作，使产品能够更直观地呈现在消费者面前，为他们提供面对面的优质服务体验。
                    </p>
                    <p style="text-indent: 2em;margin-bottom: 40px;">
                        艾乐肤（广州）生物科技有限公司将秉持专业、诚信、创新的理念，不断探索前行，持续为市场和消费者带来更多价值，努力成为行业内的领军者和佼佼者，在激烈的市场竞争中书写属于我们的辉煌篇章。
                    </p>
                    </div>
                    
                </div>

            </div>
        </div>
        <div class="row">
            <div class="col-md-6 offset-md-3">
                <div v-for="(image, index) in images" :key="index" class="mb-4 text-center">
                    <!-- <p class="desktop-image-description">{{ image.description }}</p> -->
                    <!-- <img :src="require('@/assets/images/brandInformation/' + image.filename)" :alt="image.alt"
                        class="img-fluid desktop-image" :style="{ maxHeight: image.maxHeight }"
                        @click="goToBuyPage(image.productId)"> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';
export default {
    name: 'BrandInfo', // 组件名称
    components: {
        Carousel,
        Slide
    },
    data () {
        return {
            images: [
                {
                    filename: '14.png',
                    alt: 'Image 1',
                    description: '轻盈似雪 自然定格',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '1001' // 产品ID
                },
                {
                    filename: '15.png',
                    alt: 'Image 2',
                    description: '创新雾化科技 打破定妆难题',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '1002' // 产品ID
                },
                {
                    filename: '16.png',
                    alt: 'Image 3',
                    description: '精致眼妆 悦动笔上',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '1003' // 产品ID
                },
                {
                    filename: '17.png',
                    alt: 'Image 4',
                    description: '持久卷翘 细睫出众',
                    maxHeight: '800px', // 移动端图片的最大高度
                    productId: '1004' // 产品ID
                },

            ],
        }
    }
}
</script>

<style scoped>
/* 移动端 */
@media only screen and (max-width: 996px) {
    .zhengWen{
        width: 100%;
        font-family: sans-serif;
        font-size: 1rem;
    }
}
/* 桌面端 */
@media only screen and (min-width: 996px) {
    .zhengWen{
        width: 77%;
        font-family: sans-serif;
        font-size: 21px;
    }
}
/* 样式 */
.desktop-image {
    width: 1000px;
    /* 设置图片宽度为屏幕宽度的80% */
}

.container {
    margin-top: 140px;
}

/* 图片尺寸调大 */
@media (min-width: 768px) {
    .offset-md-3 {
        margin-left: 0;
    }

    .col-md-6 {
        width: 100%;
    }

}
</style>